define( function() {
	"use strict";

	return ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/manipulation/var/rtagName.js
// module id = 112
// module chunks = 0